import React from "react";
import "./NotFound.css";

const NotFound = () => {
    return (
        <div className="not-found-wrapper">
            <div className="not-found-contents">
                <span className="not-found-text"><h1>404 : Not Found</h1></span>
            </div>
        </div>
    );
}

export default NotFound;